<template>
  <div class="transaction">
    <v-snackbar v-model="snackbarContinueTransSuccess" :timeout="4000" top color="success">
      <span>Success! Your Transaction Will Be Verified!</span> 
      <v-btn text color="white" @click="snackbarContinueTransSuccess = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="cancelSuccess" :timeout="10000" top color="success">
      <span>Successfully cancelled a transaction</span> 
      <v-btn text color="white" @click="cancelSuccess = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarContinueTransError" :timeout="4000" top color="success">
      <span>Not Successful !!!</span> 
      <v-btn text color="white" @click="snackbarContinueTransError = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="cancelfail" :timeout="10000" top color="red">
      <span>Transaction Cancellation was not successful. Please try again later!!!</span> 
      <v-btn text color="white" @click="cancelfail = false">Close</v-btn>
    </v-snackbar>
    <v-dialog persistent v-model="dialogSuccess" max-width="300px">
      <v-card>
        <v-img src="/verified.png"></v-img>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#62AE32" text @click="dialogSuccess=false">Close</v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog persistent v-model="dialogError" max-width="300px">
      <v-card>
        <v-card-text>Transaction verification was not successful. Please try again later</v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#62AE32" text @click="dialogError=false">Close</v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialog" max-width="400px">
      <v-card>
          <v-card-title>
          <span class=" black--text">Verify Transaction</span>
          </v-card-title>

          <v-card-text>
          <v-container>
              <v-card-text class="black--text">You about to verify a transaction with Id: {{id}}. <strong>Verify?</strong></v-card-text>
          </v-container>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#62AE32" text @click="dialog=false">No</v-btn>
          <v-btn color="#62AE32" text @click="verify(id)" :loading="loadVerify">Yes</v-btn>
          
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="canceldialog" max-width="400px">
      <v-card>
          <v-card-title>
          <span class=" black--text">Cancel Transaction</span>
          </v-card-title>

          <v-card-text>
          <v-container>
              <v-card-text class="black--text">You are about to cancel a transaction with Transaction Id: {{id}}. Cancelled transactions cannot be reversed <strong>Cancel?</strong></v-card-text>
          </v-container>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#62AE32" text @click="canceldialog=false">No</v-btn>
          <v-btn color="red" dark @click="cancel(id)" :loading="loadCancel">Yes</v-btn>
          
          </v-card-actions>
      </v-card>
    </v-dialog>
     <v-container>
        <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
       <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline">Transactions</v-toolbar-title>
        </v-toolbar>
       <v-tabs class="my-3" color="black" background-color="transparent">
          <v-tabs-slider color="#B45C5C"></v-tabs-slider>
        <v-tab>Premium Payment
        </v-tab>
        <v-tab>
          Claims Payment
        </v-tab>
        <v-tab>
          Verify Payments
        </v-tab>
        <v-tab>
          My Transactions
        </v-tab>
         <!-- first tab -->
         <v-tab-item >
             <v-card>
            <v-card-title flat>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="#08911B"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-select outlined label="transaction status..." color="#08911B" :items="transactionType" v-model="selectTransactionType" class="mt-8" dense @change="onChangePremiumPayment($event)"></v-select>
                </v-card-title>
                 <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="Transactions"
                    :items-per-page="10"
                    :single-select="singleSelect"
                    item-key="name"
                    :search="search"
                    class="pa-5"
                    no-data-text="No Transaction Has Been Caried Out"
                    :loading="loader"
                >
                <template v-slot:item.payment_amount="{ item }">
                      <span>&#8358;{{item.payment_amount}}</span>
                  </template>
                <template v-slot:item.action="{ item }">
                    <v-icon
                      medium
                      class="mr-2 icon-color"
                      @click="getTransactionById(item.transaction_id)"
                    >
                      mdi-chevron-right
                    </v-icon>
                  </template>

                 </v-data-table>
             </v-card>
         </v-tab-item>

         <!-- second tab -->
         <v-tab-item >
            <v-card>
              <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="#08911B"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-select outlined label="transaction status..." color="#08911B" :items="transactionType" v-model="selectTransactionStatus" class="mt-8" dense @change="onChangeClaimsPayment($event)"></v-select>
             </v-card-title>
                 <v-data-table
                    v-model="selected"
                    :headers="headers1"
                    :items="claimTransactions"
                    :single-select="singleSelect"
                    item-key="name"
                    :items-per-page="10"
                    :search="search"
                    class="pa-7 elevation-1"
                    :loading="loader"
                    no-data-text="No Transactions Has Been Carried Out"
                >
                  <template v-slot:item.payment_amount="{ item }">
                      <span>&#8358;{{item.payment_amount}}</span>
                  </template>
                 <template v-slot:item.action="{ item }">
                    <v-icon
                      medium
                      class="mr-2 icon-color"
                      @click="getTransactionById(item.transaction_id)"
                    >
                      mdi-chevron-right
                    </v-icon>
                  </template>
                  
                 </v-data-table>
             </v-card>
         </v-tab-item>
        <!-- third tab -->
          <v-tab-item >
            <!-- view verified Transactions done manually -->
            <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header class="text--black">VIEW ALL MANUALLY VERIFIED TRANSACTIONS</v-expansion-panel-header>
                  <v-expansion-panel-content class="mt-n5">
                    <v-card flat>
                      <v-card-title>
                        <v-spacer></v-spacer>
                        <v-text-field
                          v-model="searchManual"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                          color="#08911B"
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="manuallyVerified"
                        :items="ManuallyVerifiedTransactions"
                        :items-per-page="5"
                        :single-select="singleSelect"
                        hide-default-footer = true
                        item-key="name"
                        class="mt-8 px-5"
                        :search="searchManual"
                        :loading="loader"
                        no-data-text="No Recent Manually Verified Transactions To Display"
                      >
                          <!-- <template  v-slot:top>
                            
                          </template> -->
                          <template v-slot:item.payment_amount="{ item }">
                              <span>&#8358;{{item.payment_amount}}</span>
                          </template>
                          <template v-slot:item.action="{ item }">
                            <div @click="getName(item.Id)" style="color:#B45C5C; cursor: pointer;">
                              View more
                            </div>
                          </template>

                      </v-data-table>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <v-card>
              <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="#08911B"
              ></v-text-field>
              </v-card-title>
                  <v-data-table
                    v-model="selected"
                    :headers="headers2"
                    :items="pendingTransactions"
                    item-key="transaction_id"
                    :items-per-page="10"
                    :search="search"
                    class="pa-7 elevation-1"
                    no-data-text="No Pending Transactions For Manual Verification"
                >

                  <template v-slot:item.action="{ item }">
                    <v-icon
                      medium
                      class="mr-2 icon-color"

                      @click="getTransactionById(item.transaction_id)"
                    >
                      mdi-chevron-right
                    </v-icon>
                  </template>
                  <template v-slot:item.payment_amount="{ item }">
                      <span>&#8358;{{item.payment_amount}}</span>
                  </template>
                  <template v-slot:item.verify="{ item }">
                    <v-chip color="green" small dark @mouseover="getTransactionId(item.transaction_id)" @click="dialog=true">Verify</v-chip>
                  </template>
                   <template v-slot:item.cancel="{ item }">
                    <v-chip color="red" small dark @mouseover="getTransCancel(item)" @click="canceldialog=true">Cancel</v-chip>
                  </template>
                  
                  </v-data-table>
            </v-card>
          </v-tab-item>
          <!-- forth tab -->
          <v-tab-item>
            <div v-if="usertransactions.length<1" class="pa-12 text-center grey--text">No recent transactions</div>
             <v-expansion-panels max-width="800" >
              <v-expansion-panel v-for="trans in usertransactions" :key="trans.id">
                <v-expansion-panel-header class="">
                    
                    <v-row justify="space-around" no-gutters>
                        <v-col cols="12" lg="5" md="4" sm="3" class="mt-n4">
                            <v-subheader class="res1 font-weight-bold">Transaction Id</v-subheader>
                            <v-card-text class="mt-n4 font-weight-black res2">{{trans.transaction_id}}</v-card-text>
                        </v-col>
                        <v-col cols="12" lg="3" md="2" sm="3" class="mt-n4">
                            <v-subheader class="res1 font-weight-bold">Date</v-subheader>
                            <v-card-text class="mt-n4 res2 font-weight-black">{{trans.date_created}}</v-card-text>
                        </v-col>
                        <v-col cols="12" lg="2" md="4" sm="3" class="mt-n4">
                            <v-subheader class="res1 font-weight-bold">Status</v-subheader>
                            <v-card-text class="mt-n4 res2 font-weight-black">{{trans.payment_status}}</v-card-text>
                        </v-col>
                        <v-col cols="12" lg="2" md="2" sm="3" class="mt-n4">
                            <v-subheader class="res1 font-weight-bold">Recipient</v-subheader>
                            <v-card-text class="mt-n4 res2 font-weight-black">{{trans.recipient_name}}</v-card-text>
                        </v-col>
                    </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-n6">
                  <v-card max-height="300" max-width="400" color="#B45C5C" height="200" width="500" elevation="3" dark>
                    <v-row class="pa-2" no-gutters>
                      <v-col>Amount</v-col>
                      <v-col>&#8358;{{trans.payment_amount}}</v-col>
                    </v-row>
                    <v-row class="pa-2" no-gutters>
                      <v-col>Policy Number</v-col>
                      <v-col>{{trans.policy_number}}</v-col>
                    </v-row>
                    <v-row class="pa-2" no-gutters>
                      <v-col>Recipient Username</v-col>
                      <v-col>{{trans.policy_holder}}</v-col>
                    </v-row>
                    <v-row class="pa-2" no-gutters>
                      <v-col>Payment Method</v-col>
                      <v-col>{{trans.payment_method}}</v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="#B45C5C"  dark v-if="continueTrans(trans.payment_status, trans.payment_method, trans.transaction_id)" @click="dialogContinueTrans=true">Continue</v-btn> -->
                    <!-- <v-btn color="#B45C5C"  dark>Generate Receipt</v-btn> -->
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
          </v-tabs>
        </div>
       </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import OtpInput from "@bachdgvn/vue-otp-input"
export default {
  components: {
    OtpInput
  },
  data(){
    return{
    id:0,
    dialog:false,
    canceldialog:false,
    dialogSuccess:false,
    dialogError:false,
    search: '',
    dialogContinueTrans:false,
    loadVerify:false,
    loadCancel:false,
    selectTransactionType:'',
    selectTransactionStatus:'',
    transRef:'',
    transIdToContinue:'',
    transactionType:['Pending', 'Failed', 'Successful', 'All', 'InComplete'],
    headers: [
        {
        text: 'Community',
        align: 'left',
        sortable: false,
        value: 'community_name',
        },
        { text: "Depositor's Name", value: 'depositors_name' },
        // { text: 'Policy Number', value: 'policy_number' },
        { text: 'Amount', value: 'payment_amount', sortable: false },
        { text: 'Date', value: 'date_created', sortable: false },
        { text: '', value: 'action', sortable: false },
                ],
   
    headers1: [
        {
            text: 'Community',
            align: 'left',
            sortable: false,
            value: 'community_name',
        },
        { text: "Depositor's Name", value: 'depositors_name' },
        // { text: 'Policy Number', value: 'policy_number' },
        { text: 'Amount', value: 'payment_amount', sortable: false },
        { text: 'Date', value: 'date_created', sortable: false },
        { text: '', value: 'action', sortable: false },
    ],

    headers2: [
      { text: "Transaction Id", value: 'transaction_id' },
      // { text: 'Policy Number', value: 'policy_number' },
      { text: 'Amount', value: 'payment_amount', sortable: false },
      // { text: 'Payment Status', value: 'payment_status', sortable: false },
      { text: 'Date', value: 'date_created', sortable: true },
      { text: '', value: 'verify', sortable: false },
      { text: '', value: 'cancel', sortable: false },
      { text: '', value: 'action', sortable: false },
    ],
    manuallyVerified: [
      { text: "Transaction Id", value: 'transaction_id' },
      { text: 'Amount', value: 'payment_amount', sortable: false },
      { text: 'Date Verified', value: 'date_paid', sortable: true },
      { text: 'Verified By', value: 'verified_by', sortable: true },
      { text: '', value: 'action', sortable: false },
    ],
    paymentMethod:'',
    paymentMethods:['USSD', 'BANK TRANSFER', 'OVER THE COUNTER', 'OTHERS'],
    loadingConfirm:false,
    snackbarContinueTransSuccess:false,
    snackbarContinueTransError:false,
    searchManual:'',
    loader:false,
    cancelSuccess:false,
    cancelfail:false,
    transForCancel:{}
    }
  },
  computed:{
      Transactions(){
        let trans = this.$store.state.transactions.transactions
        for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2);
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
        }
        return trans
      },
      claimTransactions(){
         let trans= this.$store.state.transactions.claimTransactions
         for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2)
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
        }
        return trans
      },
      pendingTransactions(){
        let trans = this.$store.state.transactions.pendingTransactions
        for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2)
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
        }
        return trans
      },
      usertransactions(){
        let trans = this.$store.state.transactions.myTransactions
        for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2)
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
        }
        return trans
      },
      ManuallyVerifiedTransactions(){
        let trans = this.$store.state.transactions.manuallyVerified
        for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2)
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
          trans[j].date_paid= trans[j].date_paid.slice(0, 19).replace('T', ' ');
        }
        return trans
      }

  },
  methods:{
    continueTrans(status, method, id){
      if (method==="Over the Counter" && status==="Pending"){
        this.transIdToContinue = id
        return true
      }else{
        return false
      }
    },
    getTransactionId(id){
      this.id = id
    },
    getTransactionById(id){
        this.$store.dispatch("TransactionsById", id)
      .then((success)=>{
     this.$router.push(`/transactions/viewTransaction/${success.policy_holder}`)
      })
      .catch((error)=>{
      })
      
    },
    getTransCancel(trans){
      this.id= trans.transaction_id
      this.transForCancel= trans
    },
    verify(id){
      this.loadVerify=true
      this.$store.dispatch("verifyTransactions", {transactionId:id, username:this.$store.state.community.logindetails.consultant_id, })
      .then(()=>{
        this.dialog=false
        this.loadVerify=false
        this.dialogSuccess= true
        this.$store.dispatch("getPendingTransaction")
      })
      .catch(()=>{
        this.dialog=false
        this.loadVerify=false
        this.dialogError= true
      });
    },
    cancel(id){
      this.loadCancel=true
      if(this.transForCancel.claim_id===0){
        this.$store.dispatch("cancelTransactions", {username:this.transForCancel.depositor_username, consultantId:this.$store.state.community.logindetails.consultant_id, transactionId:this.transForCancel.transaction_id, subscriptionId:this.transForCancel.subscription_id})
        .then(()=>{
          this.canceldialog=false
          this.loadCancel=false
          this.cancelSuccess= true
          this.$store.dispatch("getPendingTransaction")
        })
        .catch(()=>{
          this.dialogcancel=false
          this.loadCancel=false
          this.cancelfail= true
        });
      }else{
          this.$store.dispatch("cancelTransactions", {username:this.transForCancel.depositor_username, consultantId:this.$store.state.community.logindetails.consultant_id, transactionId:this.transForCancel.transaction_id, claimId:this.transForCancel.claim_id })
          .then(()=>{
            this.canceldialog=false
            this.loadCancel=false
            this.cancelSuccess= true
            this.$store.dispatch("getPendingTransaction")
          })
          .catch(()=>{
            this.dialogcancel=false
            this.loadCancel=false
            this.cancelfail= true
          });
      }
      
    },
    continueOverTheCounterTrans(){
      this.loadingConfirm= true
      this.$store.dispatch("continueOverTheCounterTrans", {transactionId:id, username:this.$store.state.community.logindetails.consultant_id, transRefNum:this.transRef, paymentMethod:this.paymentMethod})
      .then(()=>{
        this.dialogContinueTrans=false
        this.loadingConfirm=false
        this.snackbarContinueTransSuccess= true
        this.$store.dispatch("getMyTransactions", {"username":this.$store.state.community.logindetails.consultant_id})
        this.$store.dispatch("getManuallyVerifiedTransaction")
      })
      .catch((error)=>{
        this.dialogContinueTrans=false
        this.loadingConfirm=false
        this.snackbarContinueTransError= true
      });
      
    },
    // ===========================TRANSACTION FILTERS FOR PREMIUMS AND CLAIMS====================
    onChangePremiumPayment(event){
      this.loader=true
      if (event === 'All'){
        this.$store.dispatch("getTransactions")
        .then((success)=>{
          this.loader=false
        })
        .catch((error)=>{
          this.loader=false
        });
      }else{
        this.$store.dispatch("getPremiumTransactionFilter", {status:event, type:'premium'})
        .then((success)=>{
          this.loader=false
        })
        .catch((error)=>{
          this.loader=false
        }); 
      }
    },
    onChangeClaimsPayment(event){
      this.loader=true
      if (event === 'All'){
        this.$store.dispatch("getClaimTransactions")
        .then(()=>{
          this.loader=false
        })
        .catch(()=>{
          this.loader=false
        });
      }else{
        this.$store.dispatch("getClaimTransactionFilter", {status:event, type:'Claims'})
        .then(()=>{
          this.loader=false
        })
        .catch(()=>{
          this.loader=false
        }); 
      }
    },

    // ===========================Continuing of bank transactions===========
    handleOnComplete(value) {
    },
    handleOnChange(value) {
    },

    // =====CONTINUE TRANSACTION FOR OVER THE COUNTER TRANSACTIONS====
    payMethodChanged(event){
      this.paymentMethod = event
    } 
  },
  created(){
    this.$store.dispatch("getTransactions")
    // this.loader =true
      .then(()=>{
        // this.loader=false
      })
      .catch(()=>{
        // this.loader=false
      });
      this.$store.dispatch("getClaimTransactions")
      .then(()=>{
      })
      .catch(()=>{
      });
      this.$store.dispatch("getPendingTransaction")
      .then(()=>{
      })
      .catch(()=>{
      });
      this.$store.dispatch("getManuallyVerifiedTransaction")
      .then(()=>{
      })
      .catch(()=>{
      });
      this.$store.dispatch("getMyTransactions", {"username":this.$store.state.community.logindetails.consultant_id})
      .then(()=>{
      })
      .catch(()=>{
      });
  }
}
</script>

<style scoped>
.title-color{
  color : #62ae32;
}
.transaction{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
.icon-color{
   color: #B45C5C;
}
/* tr.v-data-table__selected {
  background: #7d92f5 !important;
} */
.res1{
font-family: Lato;

color: #B45C5C
}
.res2{
font-weight: bolder;
font-family: Lato;
color: black;
}

.otp-input {
    width: 4px;
    height: 4px;
    padding: 5px;
    margin: 0 5px;
    font-size: 20px;
    border-radius: 4px; 
    border: 1px solid red;
    text-align: "center";
}
.error {
  border: 1px solid red !important;
}
</style>
